import { rest } from 'utils';
import user from './user';

export default {
  getSsoUrl: async () => {
    const { id: userId = '' } = (await user.getCurrentUser()) || {};
    return rest.get({ url: `/um/users/${userId}/s3ssourl` });
  },
};
